<div class="adesao-concluido">
  <div id="stepper1" class="bs-stepper">
    <i class="far fa-check-circle"></i>
    <h2>Dados Inseridos!</h2>
    <p>{{ mostrarBotao ? 'Confira suas escolhas de plano e conclua sua Adesão!' : 'Pagamento Concluído!!!' }}</p>
    <p>{{ mostrarBotao ? 'Selecione a forma de pagamento do primeiro aporte' : '' }}</p>

    <div class="form-group">
      <div class="info-btn">
        <p><strong>{{ mostrarBotao ? 'Forma do pagamento do primeiro aporte:' : 'Finalize sua Adesão! Clicando no botão abaixo' }}</strong></p>
      </div>
      @if (mostrarBotao) {
        <div class="button-group">
          <div style="display: flex; justify-content: center; gap: 16px; background-color: #ffffff00; padding: 20px; border-radius: 8px;">
            <button style="background-color: #033a75; color: #FFFFFF; border: none; padding: 10px 20px; border-radius: 5px; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 8px;"
              type="button"
              class="btn payment-button"
              [disabled]="botaoDesabilitado"
              (click)="salvarAporteBoleto()">
              <i class="fas fa-file-invoice-dollar" style="color: #FFFFFF;"></i> Boleto
            </button>
            <button style="background-color: #033a75; color: #FFFFFF; border: none; padding: 10px 20px; border-radius: 5px; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 8px;"
              type="button"
              class="btn payment-button"
              [disabled]="botaoDesabilitaPix"
              (click)="salvarAportePix()">
              <i class="fas fa-qrcode" style="color: #FFFFFF;"></i> Pix
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Container para exibir os dados do PIX diretamente na tela -->
    @if (dadosPix) {
      <div class="pix-dados-container-externo" style="margin: 32px auto 0 auto; max-width: 700px; background: #fff; border-radius: 16px; box-shadow: 0 4px 24px #0002; padding: 40px 32px 32px 32px; display: flex; flex-direction: column; align-items: center;">
        <div class="p-1" style="font-size: 20px; margin-bottom: 8px;">
          <span>Tipo Pagamento: <strong>Pix</strong></span><br>
          <span>Valor: <strong>{{dadosPix?.VLR_ORIGINAL | currency:'R$'}}</strong></span><br>
          <span>Vencimento: <strong>{{dadosPix?.DTA_VENCIMENTO | date:'dd/MM/yyyy'}}</strong></span>
        </div>
        <div class="mt-1 p-1" style="font-size: 16px; margin-bottom: 8px;">
          Cópia e cola:
        </div>
        <div class="codigo-boleto p-2 text-center" style="font-size: 18px; font-weight: bold; word-break: break-word; margin-bottom: 16px;">
          {{dadosPix?.DCR_COPIAECOLA}}
        </div>
        <button class="btn btn-pix-copiar" (click)="copyToClipboardAndToast(dadosPix?.DCR_COPIAECOLA, 'Código copiado')" style="background: #033a75; color: #fff; border: none; padding: 12px 28px; border-radius: 8px; font-size: 18px; font-weight: 600; display: flex; align-items: center; gap: 10px; margin-bottom: 24px; box-shadow: 0 2px 8px #0001;">
          <i class="fas fa-copy" style="color: #fff; font-size: 20px;"></i>
          COPIAR CÓDIGO
        </button>
        <div class="text-center mt-2">
          <img style="width: 200px; height: 200px;" [src]="'data:image/png;base64,' + dadosPix?.DCR_QRCODE_PNG_BASE64" alt="QR Code do Pix" />
        </div>
      </div>
    }

    <!-- Container para exibir os dados do Boleto diretamente na tela -->
    @if (dadosBoleto) {
      <div class="boleto-dados-container-externo" style="margin: 32px auto 0 auto; max-width: 700px; background: #fff; border-radius: 16px; box-shadow: 0 4px 24px #0002; padding: 40px 32px 32px 32px; display: flex; flex-direction: column; align-items: center;">
        <div class="p-1" style="font-size: 20px; margin-bottom: 8px;">
          <span>Tipo Pagamento: <strong>Boleto</strong></span><br>
          <span>Valor: <strong>{{dadosBoleto?.VLR_TITULO | currency:'R$'}}</strong></span><br>
          <span>Vencimento: <strong>{{dadosBoleto?.DTA_VENCIMENTO | date:'dd/MM/yyyy'}}</strong></span>
        </div>
        <div class="mt-1 p-1" style="font-size: 16px; margin-bottom: 8px;">
          Código para pagamento:
        </div>
        <div class="codigo-boleto p-2 text-center" style="font-size: 18px; font-weight: bold; word-break: break-word; margin-bottom: 16px;">
          {{dadosBoleto?.DCR_LIN_DIG}}
        </div>
        <button class="btn btn-boleto-copiar" (click)="copyToClipboardAndToast(dadosBoleto?.DCR_LIN_DIG, 'Código copiado')" style="background: #033a75; color: #fff; border: none; padding: 12px 28px; border-radius: 8px; font-size: 18px; font-weight: 600; display: flex; align-items: center; gap: 10px; margin-bottom: 16px; box-shadow: 0 2px 8px #0001;">
          <i class="fas fa-copy" style="color: #fff; font-size: 20px;"></i>
          COPIAR CÓDIGO
        </button>
        <button class="btn btn-boleto-pdf" [disabled]="loading" (click)="gerarPDFBoleto()" style="background: #033a75; color: #fff; border: none; padding: 12px 28px; border-radius: 8px; font-size: 18px; font-weight: 600; display: flex; align-items: center; gap: 10px; box-shadow: 0 2px 8px #0001; justify-content: center;">
          @if (!loading) {
            <span style="display: flex; align-items: center;"><i class="far fa-file-pdf" style="color: #fff; font-size: 20px; margin-right: 8px;"></i>Visualizar Boleto</span>
          }
          @if (loading) {
            <span style="display: flex; align-items: center;"><i class="fas fa-spinner fa-spin" style="color: #fff; font-size: 20px; margin-right: 8px;"></i>Visualizar Boleto</span>
          }
        </button>
      </div>
    }

    @if (!dadosPix && !dadosBoleto) {
      <p>O boleto da sua contribuição mensal será gerado pelo sistema 5 dias antes da data de vencimento e ficará disponível no autoatendimento do viva-mais</p>
    }
  </div>
</div>
